import Ajv, { type ErrorObject } from 'ajv'
import schemaJson from './aiSseV2.schema.json'

const ajv = new Ajv({ allErrors: true, strict: false })
const validate = ajv.compile(schemaJson as Record<string, unknown>)

export interface V2ValidationResult {
  ok: boolean
  errors?: ErrorObject[]
}

export function validateSseV2Envelope(data: unknown): V2ValidationResult {
  if (validate(data)) {
    return { ok: true }
  }
  return { ok: false, errors: validate.errors ?? [] }
}
